import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'formatDateTime'
})
export class FormatDateTime implements PipeTransform {

    transform(value: string | undefined): string {
        if (!value) return '';

        const date = new Date(value);
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        };

        return date.toLocaleString('de-DE', options);
    }
}
